import styled from 'styled-components';

const GiftActivityWrapper = styled.div``;

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const HeaderLeft = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const Email = styled.div`
  overflow: overlay;
`;

export { Email, GiftActivityWrapper, Header, HeaderLeft };
